import { render, staticRenderFns } from "./add.vue?vue&type=template&id=5e12fcf6&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=5e12fcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e12fcf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e12fcf6')) {
      api.createRecord('5e12fcf6', component.options)
    } else {
      api.reload('5e12fcf6', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=5e12fcf6&scoped=true&", function () {
      api.rerender('5e12fcf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/web/category/add.vue"
export default component.exports